module.exports = function (getRestrictions, value) {
  var restrictions = getRestrictions('email');
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (restrictions.length && !re.test(value)) {
    throw { message: 'email', params: { value: value } };
  }

  return value;
};
